import "./index.less";
import classNames from "classnames";
import React, { useEffect, useState } from "react";
import { useTranslationPlus } from "@/Core/i18n/useTranslationPlus";
import {
  CasinoIcon,
  ActivityIcon,
  InviteIcon,
  Vip,
  Whatsapp,
} from "@/assets/svg-icon";
import { useLocation, useNavigate } from "react-router";
import useDialogManager from "@/utils/useDialogManager";
import { useGlobalState, useMobileLeftSiderSwitch } from "@/store/commonStore";
import CollapsePlusUI from "../siderLeftMenu/CollapsePlus/CollapsePlusUI";
import CollapseItemPlusRef from "../siderLeftMenu/CollapsePlus/CollapseItemPlusUI/CollapseItemPlusUI";
import { useBeforeSetting } from "@/store/beforeSetting";
import { useGameCategories } from "@/features/common/gameCategory/useGameCategories";
import useWhatsApp from "@/features/whatsapp";
import useWhatsAppChannel from "@/features/whatsapp/useWhatsAppChannel";
import CustomerServiceEntryIcon from "@/features/whatsapp/CustomerServiceEntryIcon";

const NormalMenu = (props) => {
  const { className, collapsed, scrollRef } = props;
  const prefixCls = "normal-menu";
  const { t } = useTranslationPlus("HomeView");
  const { t: tCustomer } = useTranslationPlus("CustomerService");
  const channelUrl = useWhatsAppChannel();
  const [casinoIndex, setCasinoIndex] = useState<number>(-1);
  const navigate = useNavigate();
  const { openSignIn, openVip } = useDialogManager();
  const { data } = useBeforeSetting();
  const { isLogin } = useGlobalState();
  const [, setDrawerVisible] = useMobileLeftSiderSwitch();
  const { openCustomerService } = useWhatsApp();
  // 获取动态游戏分类
  const { menuCategories } = useGameCategories();

  // 获取whatsapp链接
  const { whatsapp } = data || {};
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname) {
      setCasinoIndex(-1);
      menuCategories?.forEach((v, i) => {
        if (v.path === pathname) {
          setCasinoIndex(i);
        }
      });
    }
  }, [pathname, menuCategories]);

  const onClickCasino = (index) => {
    setDrawerVisible(false);
    const category = menuCategories[index];
    if (category.auth && !isLogin) {
      openSignIn();
      return false;
    }
    navigate(category.path);
    setCasinoIndex(index);
    return true;
  };
  const handleWhatsappClick = () => {
    setDrawerVisible(false);
    openCustomerService();
  };
  return (
    <div className={classNames([`${prefixCls}`, className])}>
      <CollapsePlusUI
        icon={<ActivityIcon />}
        title={t("Activity")}
        collapsedLeft={collapsed}
        className={`${prefixCls}-casino`}
        scrollRef={scrollRef}
        value={pathname === "/Activity" ? "self" : -1}
        onClick={() => {
          setDrawerVisible(false);
          navigate("/Activity");
        }}
      />

      <CollapsePlusUI
        className={`${prefixCls}-casino`}
        icon={<CasinoIcon />}
        title={t("All Games")}
        collapsedLeft={collapsed}
        defaultCollapsedTop={true}
        value={casinoIndex}
        scrollRef={scrollRef}
      >
        {menuCategories?.map((category, index) => {
          return (
            <CollapseItemPlusRef
              key={index.toString()}
              index={index}
              icon={category.icon}
              onClick={onClickCasino}
              title={t(category.nameKey)}
            />
          );
        })}
      </CollapsePlusUI>

      <CollapsePlusUI
        icon={<Vip />}
        title={t("Vip")}
        collapsedLeft={collapsed}
        scrollRef={scrollRef}
        onClick={() => {
          setDrawerVisible(false);
          if (isLogin) {
            openVip();
          } else {
            openSignIn();
          }
        }}
      />

      {
        <CollapsePlusUI
          icon={<InviteIcon />}
          title={t("Affiliate")}
          collapsedLeft={collapsed}
          scrollRef={scrollRef}
          value={pathname === "/NationalProxy" ? "self" : -1}
          onClick={() => {
            if (isLogin) {
              setDrawerVisible(false);
              navigate("/NationalProxy");
            } else {
              openSignIn();
            }
          }}
        />
      }

      {channelUrl && (
        <a
          className={`${prefixCls}-channel ${prefixCls}-whatsapp`}
          href={channelUrl}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={tCustomer("whatsapp_channel")}
          title={tCustomer("whatsapp_channel")}
          onClick={() => setDrawerVisible(false)}
        >
          <span className={`${prefixCls}-channel-icon`}><Whatsapp /></span>
          {!collapsed && <span dir="auto">{tCustomer("whatsapp_channel")}</span>}
        </a>
      )}

      {/* Customer service remains independent of the official channel. */}
      {whatsapp && (
        <CollapsePlusUI
          icon={<CustomerServiceEntryIcon />}
          className={`${prefixCls}-whatsapp`}
          title={t("help")}
          collapsedLeft={collapsed}
          scrollRef={scrollRef}
          onClick={handleWhatsappClick}
        />
      )}

    </div>
  );
};

export default NormalMenu;
